export const DATE_PATTERN = 'YYYY-MM-DD';
